module.exports = __webpack_public_path__ + "static/img/schedule.b4fd411a.png";